import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetNotificationSettings, useUserSelfDetails } from '@steelbuy/data-access';
import { UserRole } from '@steelbuy/ts-shared';
import { LoadingSpinner } from '@steelbuy/ui-primitive';
import { UrgentRequestsSettingsForm } from './UrgentRequestsSettingsForm';
import { RoutePath } from '../../router/Routes';
import { FormLayout } from '../../views/layouts/form-layout/FormLayout';
import { GenericError } from '../generic-error/GenericError';
import { PageHeader } from '../page-header/PageHeader';
import './UrgentRequestsSettings.scss';

const HelperComponent = ({ heading, message }: { heading: string; message: string }) => (
    <div className="error">
        <div className="error--heading">{heading}</div>
        <div className="error--message">{message}</div>
    </div>
);

export const UrgentRequestsSettings = () => {
    const { t } = useTranslation('translation');
    const navigate = useNavigate();
    const { data: userModel } = useUserSelfDetails();
    const { data: notificationSettings, isLoading } = useGetNotificationSettings();
    const showNotificationSettings = userModel?.roles.includes(UserRole.SELLER) && notificationSettings;

    if (!userModel || isLoading) {
        return <LoadingSpinner />;
    }

    return (
        <>
            <PageHeader
                pageTitle={t('application.urgentRequestsSettings.pageHeader')}
                previousPageTitle={t('application.urgentRequestsSettings.headerBackLinkLabel')}
                onBackClick={() => navigate(RoutePath.URGENT_REQUESTS)}
            />
            <div className="urgent-requests-settings">
                <FormLayout>
                    {showNotificationSettings ? (
                        <UrgentRequestsSettingsForm notificationSettings={notificationSettings} />
                    ) : (
                        <GenericError
                            showSecondary={false}
                            showPrimary={false}
                            HelperComponent={
                                <HelperComponent
                                    heading={t('application.myAlertsSettings.errorHeading')}
                                    message={t('application.myAlertsSettings.errorMessage')}
                                />
                            }
                        />
                    )}
                </FormLayout>
            </div>
        </>
    );
};
